import type { Quiz } from '@efdigital/ll-addon-data';
import { selectValue } from '@efdigital/ll-addon-ui/modifiers/select-value';
import DictionaryEditor from '@efdigital/ll-admin-v2/components/dictionary-editor.gts';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';

import { type EditRecordSignature } from '../edit-record-base.gts';
import { EditRecordCollapse } from '../edit-record-collapse.gts';

const PDF_TEMPLATES = [
  { value: 'default', label: 'Default' },
  { value: 'certificate-v1', label: 'Certificate V1' },
  { value: 'certificate-v2', label: 'Certificate V2' },
];

const PDF_ANNOTATION_KEYS = [
  {
    key: 'pdfHeading',
    label: 'Heading',
    placeholder: '(Quiz title)',
  },
  {
    key: 'pdfDate',
    label: 'Date',
    placeholder: '(Answer date)',
  },
  {
    key: 'pdfSignedByName',
    label: 'Signed by (name)',
    placeholder: 'Adam Portlock',
  },
  {
    key: 'pdfSignedByPosition',
    label: 'Signed by (position)',
    placeholder: 'President',
  },
  {
    key: 'pdfSignatureUrl',
    label: 'Signature image',
    placeholder: 'signature-01.png',
    media: true,
  },
  {
    key: 'pdfClientName',
    label: 'Signed by (client name)',
    placeholder: '',
  },
  {
    key: 'pdfClientPosition',
    label: 'Signed by (client position)',
    placeholder: '',
  },
  {
    key: 'pdfClientSignatureUrl',
    label: 'Signature image (client)',
    placeholder: '',
    media: true,
  },
  {
    key: 'pdfClientLogoUrl',
    label: 'Logo image (client)',
    placeholder: '',
    media: true,
  },
];

export class EditQuizCertificate extends Component<EditRecordSignature<Quiz>> {
  setTemplatePdf = (event: Event) => {
    const target = event.target as HTMLSelectElement;
    this.args.item.templatePdf = target.value;
  };

  <template>
    <EditRecordCollapse
      @editLabel="Edit Certificate Settings"
      @item={{@item}}
      @context={{@context}}
      @maxDepth={{1}}
      @collapseLabel="Certificate Settings"
      ...attributes
    >
      <:help>
        <p class="form-text">
          Control the appearance of the certificate PDF.
        </p>
      </:help>
      <:form as |uniqueId isDisabled isReadOnly|>
        <fieldset disabled={{isDisabled}} class="mb-0">
          <legend class="gud-eyebrow visually-hidden">Certificate Settings</legend>

          <div class="form-group mb-3">
            <select
              class="form-control"
              id="{{uniqueId}}-template-pdf"
              {{selectValue @item.templatePdf}}
              {{on "change" this.setTemplatePdf}}
            >
              {{#each PDF_TEMPLATES as |template|}}
                <option value={{template.value}}>
                  {{template.label}}
                  ([{{template.value}}])
                </option>
              {{/each}}
            </select>
          </div>

          {{#if @item.templatePdf}}
            <div class="mb-3">
              <img
                src="/assets/images/pdf-thumbnail/{{@item.templatePdf}}.jpg"
                alt="PDF template preview"
                class="img-fluid border rounded mw-300px"
              />
            </div>
          {{/if}}

          <h4 class="gud-eyebrow mt-4">PDF Annotations</h4>
          <p class="form-text mb-3">
            Leave fields blank to use default values.
          </p>

          <DictionaryEditor
            @item={{@item}}
            @keys={{PDF_ANNOTATION_KEYS}}
            @isReadOnly={{if isReadOnly true false}}
          />
        </fieldset>
      </:form>
    </EditRecordCollapse>
  </template>
}
